import * as Colors from "material-ui/styles/colors";
import { IBagTable } from "helpers/table-bag";
import { Slug } from "constants/notifications";
import { PermissionRole } from "containers/folders/types/base";
import { Operator } from "helpers/product-collection/field_validation";
import { DoorGroupMetric } from "helpers/metrics/types";
import { IServerRollupRequest } from "helpers/query-dsl-types";
import { ILookup } from "helpers/merchant/lookup/types";

export const PIPE_CHARACTER_REGEX = new RegExp(/\|/);

export enum CollectionAction {
    Start = "start",
    Stop = "stop",
}

export enum GridParamType {
    RowGroup = "rowGroup",
    AggFunc = "aggFunc",
    Pivot = "pivot",
    Filter = "filter",
    DimensionFilters = "dimensionFilters",
    Sort = "sort",
    PinnedRowSort = "pinnedRowSort",
    Search = "search",
    CustomAttributeFilter = "customAttributeFilter",
    costTypeArg = "costType",
    currencyFilter = "currencyArg",
}

export enum SMU_FILTER {
    ExcludeSMU = "excludeSMU",
    SMUOnly = "SMUOnly",
    All = "all",
}

export enum FILTER_KEY {
    BrandID = "_brand_id",
    ProductID = "_product_id",
}

export enum EXPORT_STATUS {
    CANCELED = "CANCELED" as any,
    CREATED = "CREATED" as any,
    DEADLINE_EXCEEDED = "DEADLINE_EXCEEDED" as any,
    FAILED = "FAILED" as any,
    FINISHED = "FINISHED" as any,
}

export enum NAMESPACE_KEYS {
    SESSION_READ_WRITE = "SESSION" as any,
    SESSION_READ_ONLY = "SESSION_READ_ONLY" as any,
    REQUEST = "REQUEST" as any,
}

export enum View {
    Grid = "grid" as any,
    Tile = "tile" as any,
    History = "history" as any,
    Brand = "brand" as any,
    CART = "cart" as any,
    Timeline = "timeline" as any,
    Door = "door" as any,
    ExportStatusLog = "export-status-log" as any,
    ValidationErrorLog = "validation-error-log" as any,
    Dataloss = "dataloss" as any,
}

export enum Mode {
    Cart = "cart",
    Review = "review",
}

export enum Panel {
    HISTORY = "history" as any,
    CHAT = "chat" as any,
    ImageGroups = "imageGroups" as any,
    ImageGroup = "imageGroup" as any,
}

export enum PinnedDto {
    UNPINNED = "UNPINNED",
    LEFT = "PIN_LEFT",
    RIGHT = "PIN_RIGHT",
}
export interface IParams {
    id: string;
    brand?: string;
    panel?: Panel;
}

export const ppsArgs = {
    us_cost: [
        { value: "us_cost" },
        { value: "cost_vendor_pps" },
        { value: 0 },
        { value: "USD" },
        { items: [{ properties: { eq: { value: "US" }, field: { value: "channel" }, index: { value: 1 } } }] },
    ],
    us_retail: [
        { value: "us_retail" },
        { value: "retail_vendor_pps" },
        { value: 0 },
        { value: "USD" },
        { items: [{ properties: { eq: { value: "US" }, field: { value: "channel" }, index: { value: 1 } } }] },
    ],
    ca_cost: [
        { value: "ca_cost" },
        { value: "cost_vendor_pps" },
        { value: 0 },
        { value: "CAD" },
        { items: [{ properties: { eq: { value: "Canada" }, field: { value: "channel" }, index: { value: 1 } } }] },
    ],
    ca_retail: [
        { value: "ca_retail" },
        { value: "retail_vendor_pps" },
        { value: 0 },
        { value: "CAD" },
        { items: [{ properties: { eq: { value: "Canada" }, field: { value: "channel" }, index: { value: 1 } } }] },
    ],
};

export const UScountryFilter = [{ eq: "US" }];
export const CAcountryFilter = [{ eq: "Canada" }];

export const USER_COLORS = [
    Colors.green500,
    Colors.red500,
    Colors.purple500,
    Colors.lightGreen500,
    Colors.pink500,
    Colors.deepPurple500,
    Colors.lime500,
    Colors.indigo500,
    Colors.orange500,
    Colors.brown500,
    Colors.amber500,
    Colors.yellow500,
    Colors.deepOrange500,
];

export const ALLOCATION_BAG_REF_CONTEXT_ATTRIBUTE = "allocationBagRef";

export const AUTOSIZE_COLUMNS = "autosizeColumns";

export const UI_COLUMN_DRAGGED = "uiColumnDragged";

export const COLUMN_EVENT_SOURCES = ["toolPanelUi", "contextMenu", "columnMenu", "toolPanelDragAndDrop"];

export const Permissions = PermissionRole;

export interface IField {
    display_name: string;
    fe_lookup_type?: string;
    field_name: string;
    field_value_delimiter?: string;
    formula?: string;
    kind: Kinds;
    value_type: ValueTypes;
    lookup_plan?: ILookup;
    [key: string]: any;
}

export interface IItemDisplayProperties {
    allocation_enabled: boolean;
    identifier_fields: string[];
    merchant_name: string;
    keys: IField[];
    door_group_metrics: DoorGroupMetric[];
}

export enum Kinds {
    RATING_STAR = "RATING_STAR",
    MULTILINE_TEXT = "MULTILINE_TEXT",
    IMAGE_URL = "IMAGE_URL",
    DEFAULT_KIND = "DEFAULT_KIND",
    ASSORTMENT_LINK_KIND = "ASSORTMENT_LINK_KIND",
    FORMULA = "FORMULA",
    INLINE_FORMULA = "INLINE_FORMULA",
    BRAND_NAME = "BRAND_NAME",
    DOOR_BULK_QUANTITY = "DOOR_BULK_QUANTITY",
    TOTAL_ALLOCATION_DIMENSIONS = "TOTAL_ALLOCATION_DIMENSIONS",
    DOOR_ACTUAL_QUANTITY = "DOOR_ACTUAL_QUANTITY",
    SIZE_PROFILE_SELECTED = "SIZE_PROFILE_SELECTED",
    SIZE_DISTRIBUTION = "SIZE_DISTRIBUTION",
    SIZES = "SIZES",
    SIZE_ORDER = "SIZE_ORDER",
    SIZE_RANGE = "SIZE_RANGE",
    PERCENT_DISTRIBUTION = "PERCENT_DISTRIBUTION",
    DOOR_NUMBER = "DOOR_NUMBER",
    DOOR_CLASSIFICATION = "DOOR_CLASSIFICATION",
    SIZES_SELECTED = "SIZES_SELECTED",
    SIZE_CURVE_METHOD = "SIZE_CURVE_METHOD",
    SIZE_CURVE_STATUS = "SIZE_CURVE_STATUS",
    ALLOCATION_DIMENSION_CLASSIFICATION = "ALLOCATION_DIMENSION_CLASSIFICATION",
    PACKS_TYPE = "PACKS_TYPE",
    PACKS_SELECTED = "PACKS_SELECTED",
    PACKS_MAX_PER_PROD = "PACKS_MAX_PER_PROD",
    PACKS_MAX_PER_DOOR = "PACKS_MAX_PER_DOOR",
    PACKS_RESULTS = "PACKS_RESULTS",
    EXPORT_ITEM_STATUS = "EXPORT_ITEM_STATUS",
    EXPORT_PO_STATUS = "EXPORT_PO_STATUS",
    EXPORT_ITEM_VALIDATION = "EXPORT_ITEM_VALIDATION",
    EXPORT_PO_VALIDATION = "EXPORT_PO_VALIDATION",
    INVENTORY_DEFAULT = "INVENTORY_DEFAULT",
    INVENTORY_TOTAL_UNITS = "INVENTORY_TOTAL_UNITS",
    INVENTORY_UNITS_PER_SIZE = "INVENTORY_UNITS_PER_SIZE",
    DOOR_COUNT_KIND = "DOOR_COUNT_KIND",
    BRAND_ITEM_SIZES = "BRAND_ITEM_SIZES",
    DEPARTMENT_LOOKUP = "DEPARTMENT_LOOKUP",
    PRICE_WITH_STRIKETHROUGH = "PRICE_WITH_STRIKETHROUGH",
}

export enum ExportStatuses {
    None = "None",
    Sent = "Sent",
    Partial = "Partial",
}

export enum ValueTypesToMerchantTableMappings {
    NUMBER = "int64_value",
}

export enum ValueTypes {
    NUMBER = "NUMBER" as any,
    STRING = "STRING" as any,
    BOOL = "BOOL" as any,
    DATE = "DATE" as any,
    ONEOF = "ONEOF" as any,
    SOMEOF = "SOMEOF" as any,
    WITH_PERCENT = "WITHPERCENT" as any,
    WITH_STRIKE = "WITHPERCENT" as any,
    ARRAY = "ARRAY" as any,
    RANGE = "RANGE" as any,
}

export enum AggFuncs {
    NONE = "NONE",
    SUM = "SUM",
    SUM_WITH_PERCENT = "sum(%)",
    AVG = "AVG",
    COUNT = "COUNT",
    COUNT_WITH_PERCENT = "count(%)",
}

export const IMAGE_URL = "image_url";
export const CAPTURED_BULKS = "captured_bulks";
export const TILE_VIEW_DOOR_COUNT = "_tile_view_door_count";
export const IMAGE_URL_STRING = "image_url_string";
export const IMAGE_COLUMN_MIN_WIDTH = 144;
export const IMAGE_COLUMN_MAX_WIDTH = 480;
export const IMAGE_COLUMN_BUFFER = 10;
export const ROW_HEIGHT = 48;
export const MENU_HIDE = 50;

export const EXCEL_STYLES = {
    STRING_CELL_CLASS: "stringCellClass",
    CURRENCY_CELL_CLASS: "currencyCellClass",
    PERCENT_CELL_CLASS: "percentCellClass",
    INTEGER_CELL_CLASS: "integerCellClass",
};

export class CardView {
    static ALLOW_FILTER = "allow_filter";
    static ALLOW_SORT = "allow_sort";
    static ALLOW_GROUP = "allow_group";
    static FIELDS = [
        "is_title",
        "is_subtitle",
        "is_cost",
        "is_color",
        "is_retail",
        // "is_subtext",
        "is_text",
    ];
}

export class ShopView {
    static FIELDS = ["is_title", "is_subtitle", "is_cost", "is_color", "is_retail"];
}

export class DetailView {
    static FIELDS = [
        "is_title",
        "is_subtitle",
        "is_cost",
        "is_retail",
        "is_total_units",
        "is_total_cost",
        "is_total_retail",
    ];
}

export enum FieldKeys {
    SELECTED_SIZE_RANGE = "_selected_size_range",
    SIZE_CURVE_METHOD = "_size_method",
}

export enum ItemBagType {
    Allocations = "allocations",
    Bulks = "bulks",
}

export enum ItemFields {
    Allocation = "allocations",
    Bulks = "bulks",
    Fields = "fields",
    PackAllocation = "pack_allocations",
    PoCreationExports = "po_creation_exports",
    InventoryUnits = "inventory_units",
    TotalUnits = "total_units",
    TotalRetail = "total_retail",
    TotalCost = "total_cost",
    DiscountedValue = "discount",
    costPPS = "cost_vendor_pps",
    retailPPS = "retail_vendor_pps",
}

export enum ColDefType {
    BooleanValue = "bool_value",
    StringValue = "string_value",
    NumberValue = "number_value",
}

export enum SizeAllocationType {
    Class = "CLASS",
    Row = "ROW",
}
export enum TotalPps {
    WHOLESALE = "WHOLESALE",
    RETAIL = "RETAIL",
    COST_VENDOR_PPS = "cost_vendor_pps",
    RETAIL_VENDOR_PPS = "retail_vendor_pps",
}

export interface IItemFieldValue {
    struct_value?:
        | {
              [key: string]: string;
          }
        | null
        | undefined;
    string_value?: string | string[] | null;
    number_value?: number | null;
    bool_value?: boolean | null;
    date_value?: {
        day: number;
        month: number;
        year: number;
    } | null;
    range_value?: [number, number];
}

export interface IItemField {
    [field: string]: IItemFieldValue | null | undefined;
}
export interface IGridItem {
    [ItemFields.Allocation]?: IBagTable;
    [ItemFields.Bulks]?: IBagTable;
    [ItemFields.InventoryUnits]?: IBagTable;
    [ItemFields.Fields]: IItemField;
    rowId?: string;
}

export interface IDefaultItem {
    [ItemFields.Fields]: {
        struct_value: {
            [field: string]: {
                string_value?: string | null;
                number_value?: number | null;
                bool_value?: boolean | null;
                date_value?: {
                    day: number;
                    month: number;
                    year: number;
                } | null;
            };
        };
    };
}

export const CollectionKeys = {
    ITEM_DISPLAY_PROPERTY: {
        KEYS: ["item_display_property", "struct_value", "keys"],
        SIZE_ALLOCATION_TYPE: ["item_display_property", "struct_value", "size_allocation_type"],
        ALLOW_DUPLICATE_PRODUCT_ENTRIES: ["item_display_property", "struct_value", "allow_duplicate_product_entries"],
        MERCHANT_NAME: ["item_display_property", "struct_value", "merchant_name"],
        DEFAULT_DATE_FORMAT: ["item_display_property", "struct_value", "default_date_format"],
        DEFAULT_CURRENCY: ["item_display_property", "struct_value", "default_currency_format", "currency"],
        SIZE_TABLE_TYPE: ["item_display_property", "struct_value", "size_table_type"],
        ALLOCATION_ENABLED: ["item_display_property", "struct_value", "allocation_enabled"],
        UNITS_ENTRY_TYPE: ["item_display_property", "struct_value", "units_entry_type"],
        TILE_VIEW_CONFIGS: ["item_display_property", "struct_value", "tile_view_configs"],
        VALIDATION_PROPERTIES: ["item_display_property", "struct_value", "validation_properties"],
        DOOR_GROUP_METRICS: ["item_display_property", "struct_value", "door_group_metrics"],
    },
    PACK_SIZING_TOLERANCE: ["pack_sizing_tolerance", "struct_value"],
    MERCHANT_SHARED_SETTINGS: {
        MARKET_SETTINGS_DO_NOT_AUTO_DISPLAY: [
            "merchant_shared_settings",
            "struct_value",
            "market_settings_do_not_auto_display",
        ],
    },
};

export const PoiTag = {
    COLLECTION_VERSION_STATUS_ID: "collection_version_status_id",
    POI_ID: "poi_id",
};

export const SIZE_PACKS_STATE_PATH = ["collection", "sizePacks"];

export const NUMBER_FORMAT_CURRENCY_SYMBOL = ["number_format", "currency", "symbol"];

export const Item = {
    ALLOCATIONS: [ItemFields.Allocation],
    BULKS: [ItemFields.Bulks],
    PO_CREATION_BULKS: [ItemFields.PoCreationExports],
    PACK_ALLOCATIONS: [ItemFields.PackAllocation],
    INVENTORY_UNITS: [ItemFields.InventoryUnits],
    FIELDS: {
        ID: [ItemFields.Fields, "id", "string_value"],
        PRODUCT_ID: [ItemFields.Fields, "_product_id", "string_value"],
        IMAGE_URL: [ItemFields.Fields, "image_url", "string_value"],
        IMAGE_URLS: [ItemFields.Fields, "image_urls", "string_value"],
        CDN_IMAGES: [ItemFields.Fields, "_cdn_images", "string_value"],
        ADDITIONAL_IMAGE_URLS: [ItemFields.Fields, "additional_image_urls", "string_value"],
        PRODUCT_REVISION: [ItemFields.Fields, "_product_revision", "string_value"],
        BRAND_ID: [ItemFields.Fields, "_brand_id", "string_value"],
        COLOR: [ItemFields.Fields, "color", "string_value"],
        COLOR_SWATCHES: [ItemFields.Fields, "_color_swatches", "string_value"],
        SIZES: [ItemFields.Fields, "_sizes", "string_value"],
        SIZE_CURVE_METHOD: [ItemFields.Fields, "_size_method", "string_value"],
        SIZE_CURVE_STATUS: [ItemFields.Fields, "_size_status", "string_value"],
        SIZE_CURVE: [ItemFields.Fields, "curve", "string_value"],
        SIZES_SELECTED: [ItemFields.Fields, "selected_sizes", "string_value"],
        SELECTED_SIZE_RANGE: [ItemFields.Fields, FieldKeys.SELECTED_SIZE_RANGE, "string_value"],
        NU_SIZE_CODES: [ItemFields.Fields, "_nu_size_codes", "string_value"],
        SIZE_IDS: [ItemFields.Fields, "_size_ids", "string_value"],
        UPC: [ItemFields.Fields, "_upcs", "string_value"],
        VENDOR_SIZES: [ItemFields.Fields, "_vendor_sizes", "string_value"],
        VARIANT_COLORS: [ItemFields.Fields, "_variant_colors", "string_value"],
        ASSORTMENT_FIELD_NAME: [ItemFields.Fields, "assortment_name", "string_value"],
        MEDIA: [ItemFields.Fields, "_media", "string_value"],
        NRF_SIZE_CODE: [ItemFields.Fields, "_nrf_size_codes", "string_value"],
        NRF_SIZE_DESCRIPTION: [ItemFields.Fields, "_nrf_size_descriptions", "string_value"],
        NU_SIZES_MANUFACTURED: [ItemFields.Fields, "_nu_sizes_manufactured", "string_value"],
        PACKS_SELECTED: [ItemFields.Fields, "packs_selected", "string_value"],
        PACK_TYPE: [ItemFields.Fields, "packs_type", "string_value"],
        PACKS_PER_PRODUCT: [ItemFields.Fields, "packs_max_per_prod", "string_value"],
        PACKS_PER_DOOR: [ItemFields.Fields, "packs_max_per_door", "string_value"],
        PACK_IDS: [ItemFields.Fields, "__pack_ids", "string_value"],
        PACKS_NOTES: [ItemFields.Fields, "packs_notes", "string_value"],
        PACK_RESULTS: [ItemFields.Fields, "packs_results", "string_value"],
        ITEM_CREATED: [ItemFields.Fields, "_export_item_status", "string_value"],
        PO_CREATED: [ItemFields.Fields, "_export_po_status", "string_value"],
        //GOA fields
        LINE_ITEM_ID: [ItemFields.Fields, "_line_item_id", "string_value"],
        STYLE_NUMBER: [ItemFields.Fields, "style_number", "string_value"],
        WAREHOUSE_ID: [ItemFields.Fields, "warehouse_id", "string_value"],
        PREBOOK: [ItemFields.Fields, "prebook", "bool_value"],
        SEASON: [ItemFields.Fields, "season", "string_value"],
        SEASONS: [ItemFields.Fields, "seasons", "string_value"],
        DEPARTMENT: [ItemFields.Fields, "department", "string_value"],
        //PPS fields
        PPS_INDICATOR: [ItemFields.Fields, "pps_indicator", "bool_value"],
        COST_VENDOR_PPS: [ItemFields.Fields, "cost_vendor_pps", "struct_value"],
        RETAIL_VENDOR_PPS: [ItemFields.Fields, "retail_vendor_pps", "struct_value"],
        //Reporting fields
        BUYER_NAME: [ItemFields.Fields, "buyer_name", "string_value"],
        BUYER_NUMBER: [ItemFields.Fields, "buyer_number", "string_value"],
    },
};

export const Door = {
    FIELDS: {
        NUMBER_OF_DOORS: [ItemFields.Fields, "_number_of_doors", "number_value"],
    },
};

export const SchemaField = {
    FIELDS: {
        ALLOWED_VALUES: ["constraint", "allowed_values"],
    },
};

export const SIZE_RANGE_DELIMITER = "::";
export const UPC_DELIMITER = ",";
export const NRF_DELIMITER = ",";
export const MANUFACTURED_SIZES_DELIMITER = ",";
export const SELECTED_SIZES_DELIMITER = ",";
export const MANUALLY_ADDED_SIZES_DELIMITER = "|";
export const SIZE_PACKS_DELIMITER = ",";
export const COMMA_DELIMITER = ",";
export const SEMICOLON_DELIMITER = ";";

export enum PurchaseOrder {
    US_ELC = "us_elc",
    US_CPD = "us_cpd",
    CA_ELC = "ca_elc",
    CA_CPD = "ca_cpd",
}

export const LINESHEET_PAGE_SIZE = 50;

export const ASSORTMENT_COPY_ITEMS = "assortment-copy-items";
export const ASSORTMENT_COPY_ALLOCATIONS = "assortment-copy-allocations";

export const CurrencyDictionary = {
    $: "USD",
    CA$: "CAD",
    "€": "EUR",
    "£": "GBP",
};

export const MERCHANT_ALLOCATION_DIMENSION_ID_PREFIX = "merchant_allocation_dimension/";

export const ROOT_NAMESPACE = "nuorder.service.collection";
export const ROOT_ID = "00000000-0000-0000-0000-000000000000";
export const ITEMS_NAMESPACE = "nuorder.service.collection.items";
export const ITEMS_ID = "00000000-0000-0000-0000-000000000001";
export const ITEM_DISPLAY_PREFERENCES_NAMESPACE = "nuorder.service.collection.item_display_preferences";
export const MERCHANT_ITEM_DISPLAY_PREFERENCES_NAMESPACE =
    "nuorder.service.collection.merchant_item_display_preferences";
export const REVIEW_DISPLAY_PREFERENCES_NAMESPACE = "nuorder.service.collection.review_display_preferences";
export const COLLECTION_POI_TAGS_NAMESPACE = "nuorder.service.collection.collection_poi_tags";
export const COLLECTION_POI_TAGS_ID = "collection_poi_tags";
export const ITEM_DISPLAY_PREFERENCES_ID = "item_display_preferences";
export const COLLECTION_FEED_SLUG = Slug.COLLECTION;
export const ALLOCATION_BAG_ID = "bag_value";
export const DOORS_ID = "DOORS";
export const DOORS_NAMESPACE = "nuorder.service.collection.doors";
export const ALLOCATION_DIMENSION_ID_PREFIX = "allocation_dimension_";
export const ALLOCATION_DIMENSIONS_ID = "ALLOCATION_DIMENSIONS";
export const ALLOCATION_DIMENSIONS_NAMESPACE = "nuorder.service.collection.allocation_dimensions";
export const DELIVERY_PURCHASE_ORDERS_NAMESPACE = "nuorder.service.collection.delivery_purchase_orders";
export const DELIVERY_PURCHASE_ORDERS_ID = "delivery_purchase_orders";
export const COLLECTION_MERCHANT_PREFERENCE_NAMESPACE = "nuorder.service.collection.merchant_preference";
export const REVIEW_PLANS_NAMESPACE = "nuorder.service.collection.review_plans";
export const REVIEW_PLAN_ID_PREFIX = "review_plan_";
export const DEFAULT_ITEM_NAMESPACE = "nuorder.service.collection.default_item";
export const ALLOCATION_BAG_NAMESPACE = "nuorder.service.collection.allocation_bag";
export const EXPORT_VALIDATION_STATUS_NAMESPACE = "nuorder.service.collection.export_validation_status";
export const DEFAULT_ITEM_ID = "default_item";

// Financial target objects
export const TARGET_BAG_ID = "target_bag_value";
export const TARGET_GROUPS_ID = "target_groups";
export const TARGETS_ID = "targets";
export const TARGET_BAG_NAMESPACE = "nuorder.service.collection.target_allocation_bag";
export const TARGET_GROUPS_NAMESPACE = "nuorder.service.collection.target_groups";
export const TARGETS_NAMESPACE = "nuorder.service.collection.targets";

export const DEFAULT_LINESHEET_FILTERS = {
    __meta: true,
    __fields: "__all",
    __limit: LINESHEET_PAGE_SIZE,
    __populate: ["__item", "__variant"],
    __archived: false,
    __view_disabled: false,
};
export const ONE_SIZE = "ONE SIZE";
export const ONE_SIZE_CURVE_NAME = "ONE SIZE";
export const SIZE_PACKS_EACHES = "";
export enum SeverityMessages {
    None = "None",
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
    Success = "Success",
}

export enum ItemValidationErrors {
    Error = "Validation finished with errors",
    Warning = "Validated finished with warnings",
    Validated = "Validation finished",
}

export enum SizingErrors {
    CurveNotFound = "Size curve not found",
    DoorCurveNotFound = "Door curve not found",
    CurveContainsZeroUnits = "Manually added size(s) contain zero units",
    SizeTotalsDotNotMatchBulks = "Size totals do not match bulks",
    BulkPackConstraintsMismatch = "Bulk units do not align with pack constraints",
    PackConstraintsInfeasible = "Sizing was unsuccessful with the selected tolerance",
    SelectedSizesAndPacksMismatch = "Selected Sizes do not align with Packs",
    NoMatch = "No match",
    Generic = "Error",
}

export enum SizeRangesErrors {
    SizeRangesNotFound = "No size range found",
    SizeRangesDoNotMatch = "Matching size range not found",
}

export enum SizeCurveStatus {
    None = "None",
    Manual = "Manual",
    Partial = "Partial",
    Sized = "Sized",
    Error = "Error",
}

export enum ItemValidationStatus {
    Validated = "Validated",
    Error = "Error",
}

export enum SizeCurveMethod {
    VendorMatched = "Vendor Matched",
    Manual = "Manual",
    Error = "Error",
}

export enum Editors {
    DropdownSizesEditor = "dropdownSizesEditor",
    NuRichSelectCellEditor = "nuRichSelectCellEditor",
    AgRichSelectCellEditor = "agRichSelectCellEditor",
    NumberCellEditor = "numberCellEditor",
    DatePickerCellEditor = "datePickerCellEditor",
    SingleChoiceCellEditor = "singleChoiceCellEditor",
    MultipleChoiceCellEditor = "multipleChoiceCellEditor",
    GenericReduxConnectedRenderer = "reduxConnectedRenderer",
    PackTypeCellEditor = "packTypeCellEditor",
    SizeCellEditor = "sizeCellEditor",
    SizeRenderer = "sizeRenderer",
    GroupRenderer = "groupRenderer",
    ItemRenderer = "itemRenderer",
    ProductItemRenderer = "productItemRenderer",
    PinnedFooterModalRowRenderer = "pinnedFooterModalRowRenderer",
    PinnedFooterRowRenderer = "pinnedFooterRowRenderer",
    DoorGroupsSelectCellEditor = "doorGroupsSelectCellEditor",
    DateCellRenderer = "dateCellRenderer",
}
export enum ToolPanels {
    Columns = "columns",
    Filters = "filters",
    Smu = "smu",
    Sort = "sort",
    Views = "views",
    Shop = "shop",
    Pivot = "pivot",
    Dimension = "dimension",
}

export enum SizeTableTypes {
    Grouped = "GROUPED",
    Default = "DEFAULT",
}

export enum UnitsEntryType {
    Total = "TOTAL",
    Average = "AVERAGE",
    GroupAverage = "GROUP_AVERAGE",
}

export const NORD_DEPT_NAME = "nordstrom_department";

// Export
export interface IExportParams {
    merchantName?: string;
    queryFilter?: IServerRollupRequest;
    view?: string;
    type?: ExportRequestType;
    rowOrder?: { field: string; order: string };
    actionMessage?: ExportMerchant | undefined;
    includeAssortmentId?: boolean;
    collectionId?: string;
    exportFileName?: string;
    rollupSnapshotId?: string;
    showExportToMerchant?: boolean;
    numberOfRows?: number;
    supplier: string;
    visibleRowsList?: string[];
    visibleColumnsList?: string[];
    exportOnlyVisibleColumns?: ExportCollectionSelectedSetting;
    exportOnlyVisibleRows?: ExportCollectionSelectedSetting;
    withImages: boolean;
    withNotes?: boolean;
    withUnits: boolean;
    unitType: ExportCollectionUnitType;
    layout?: ExportLayout;
    selectedAllocationDimensions: string[];
    horizontalAllocationDimensions: string;
    isUpcExporting?: boolean;
}

export enum ExportCollectionSelectedSetting {
    All = "ALL",
    Visible = "VISIBLE",
    Selected = "SELECTED",
}

export enum ExportCollectionUnitType {
    Actual = "ACTUAL",
    Bulk = "BULK",
    Inventory = "INVENTORY",
}

export enum ExportCloseoutUnitType {
    PlannedUnits = "PLANNED_UNITS",
    AvailableUnits = "AVAILABLE_UNITS",
}

export enum ExportLayout {
    Vertical = "VERTICAL",
    Horizontal = "HORIZONTAL",
}

export enum ExportRequestType {
    Excel = "EXCEL",
    Ftp = "FTP",
    Csv = "CSV",
    JsonIngestionFtp = "JSON_INGESTION_FTP",
}

export enum ExportMerchant {
    Saks = "saks",
    Blm = "blm",
    Jwn = "jwn",
    QaRetailer = "qaRetailer", // e2e purposes
}

export const getExportMerchantByName = (merchantName: string): ExportMerchant | undefined => {
    switch (merchantName.toLowerCase()) {
        case "saks fifth avenue":
            return ExportMerchant.Saks;
        case "bloomingdales":
            return ExportMerchant.Blm;
        case "nordstrom":
            return ExportMerchant.Jwn;
        case "qa_retailer":
            return ExportMerchant.QaRetailer;
        default:
            return undefined;
    }
};

export enum SizePacksToleranceThreshold {
    Both = "BOTH",
    Above = "ABOVE",
    Below = "BELOW",
}
export interface ISizePacksTolerance {
    value: number;
    direction: SizePacksToleranceThreshold;
}

export enum TileViewSize {
    Small = "SMALL",
    Medium = "MEDIUM",
    Large = "LARGE",
}

export enum ValidationModes {
    ValidateItems = "EXPORT_ITEM",
    ValidatePOs = "EXPORT_PO",
    Global = "GLOBAL",
}

export enum ValidationLevel {
    WARN = "WARN",
    ERROR = "ERROR",
}

export const notePrefix = "_notes_";

/**
 * Returns rule specific messages in raw (non-localized) format and is used for csv exports.
 * @param field
 * @param value
 * @param rule
 * @param product
 * @returns
 */
export const getRuleSpecificMessagesRaw = (rule: Operator): string => {
    let message = "";
    switch (rule) {
        case Operator.Eq:
            message = '[strong]|field|[strong] must be equal to [strong]"|value|"[strong]';
            break;
        case Operator.Neq:
            message = '[strong]|field|[strong] must be not equal to [strong]"|value|"[strong]';
            break;
        case Operator.Gt:
            message = "[strong]|field|[strong] must be greater than [strong]|value|[strong]";
            break;
        case Operator.Gte:
            message = "[strong]|field|[strong] must be greater than or equal to [strong]|value|[strong]";
            break;
        case Operator.Lt:
            message = "[strong]|field|[strong] must be less than [strong]|value|[strong]";
            break;
        case Operator.Lte:
            message = "[strong]|field|[strong] must be must be less than or equal to [strong]|value|[strong]";
            break;
        case Operator.NotContains:
            message = '[strong]|field|[strong] cannot contain [strong]"|value|"[strong]';
            break;
        case Operator.MaxLength:
            message = "[strong]|field|[strong] has a [strong]|value|[strong] character limit";
            break;
        case Operator.IsNumber:
            message = "[strong]|field|[strong] must be numeric";
            break;
        case Operator.IsAlpha:
            message = "[strong]|field|[strong] must be alpha";
            break;
        default:
            // eslint-disable-next-line no-console
            console.warn("No matching rule found for rule specific messages");
    }
    return message;
};

export const getValueOverrideRuleMessagesRaw = (operator: Operator, value?: string) => {
    let message = "";
    if (value === "") {
        switch (operator) {
            case Operator.Neq:
                message = "[strong]|field|[strong] is required";
                break;
            case Operator.Eq:
                message = "[strong]|field|[strong] must be empty";
                break;
        }
    } else if (value === " ") {
        switch (operator) {
            case Operator.NotContains:
                message = "[strong]|field|[strong] cannot contain spaces";
                break;
        }
    } else if (!value) {
        // when value is null | undefined.
        switch (operator) {
            case Operator.Neq:
                message = "[strong]|field|[strong] is required";
                break;
            case Operator.Eq:
                message = "[strong]|field|[strong] must be empty";
                break;
            case Operator.NotContains:
                message = "[strong]|field|[strong] cannot contain spaces";
                break;
        }
    }
    return message;
};

export const SIZES_MANUFACTURED_COLUMN_ID = "_sizes_manufactured"; // To be removed when row validation is available
export const retailKnowledgeBaseUrl = "https://nuorder-retailer.zendesk.com/hc/en-us";

export const TILE_VIEW_IMAGE_HEIGHT_SMALL = 76;
export const TILE_VIEW_IMAGE_WIDTH_SMALL = 49;
export const TILE_VIEW_IMAGE_HEIGHT_MEDIUM = 228;
export const TILE_VIEW_IMAGE_WIDTH_MEDIUM = 148;
export const TILE_VIEW_IMAGE_HEIGHT_LARGE = 328;
export const TILE_VIEW_IMAGE_WIDTH_LARGE = 248;

export const TILE_VIEW_ITEM_SIZES = {
    SMALL: {
        WIDTH: 100,
        HEIGHT: 252,
        CART_TOTALS: 94,
    },
    MEDIUM: {
        WIDTH: 164,
        HEIGHT: 396,
        CART_TOTALS: 81,
    },
    LARGE: {
        WIDTH: 264,
        HEIGHT: 480,
        CART_TOTALS: 66,
    },
    OFFSET: {
        HORIZONTAL: 16,
        VERTICAL: 16,
    },
    HEIGHT_LINE: {
        DEFAULT: 16,
        COLOR: 22,
    },
};

export const SIZES_ORDER_REFERENCE = [
    "XXXS",
    "XXS",
    "XXS/XS",
    "XS",
    "XS/S",
    "S",
    "S/M",
    "M",
    "M/L",
    "L",
    "L/XL",
    "XL",
    "XL/XXL",
    "XXL",
    "XXXL",
    "XXXXL",
    "XXXXXL",
    "XXXXXXL",
    "PP/PS",
    "PM/PL",
    "U",
    "ONE SIZE",
    "OS",
    "0-3 M",
    "3-6 M",
    "6-9 M",
    "9-12 M",
    "12-18 M",
    "18-24 M",
    "1Y",
    "2Y",
    "00",
];
export interface IDeliveries {
    units: number;
    retail: number;
    wholesale: number;
    skus: { [key: string]: boolean };
}

export interface IBuiltDoorTotals {
    "1": {
        units: number;
        deliveries: {
            [key: string]: IDeliveries;
        };
    };
    _total: {
        units: number;
        retail: number;
        wholesale: number;
        skus: {
            [key: string]: boolean;
        };
        deliveries: {
            [key: string]: IDeliveries;
        };
    };
}

export type ISelectedAllocDimension = string[];

export const ATTRIBUTE_GROUP_DELIMITER = ",";

export const MAX_USER_CUSTOM_ATTRIBUTES = 15;

export const COLUMN_DOOR_DELIVERY_THRESHOLD = 2000;

export const ATTRIBUTE_METRICS_THRESHOLD = 800;

export const COLUMN_METRICS_DELIVERY_THRESHOLD = 5;

export enum DimensionTypes {
    Doors = "Doors",
    Dates = "Dates",
    Deliveries = "Deliveries",
}

export const MAX_MUTATION_OPERATION_LIMIT = 50000;

export const PPS_INDICATOR = "pps_indicator";

export const MARKET_SETTINGS_DEPARTMENT_LOOKUP_KEY = "MARKET_SETTINGS_DEPARTMENT_LOOKUP_KEY";

export const AG_GRID_SCROLLABLE_EL_SELECTOR = "div[ref=eViewport]";
